<template>
  <div class="container">
    <h4 class="is-size-6-mobile is-size-5-tablet">
      <span class="countTotal">({{ $t("shipmentQtyGraph.total") }} {{ count }})</span>
    </h4>
    <div class="box">
      <div class="columns is-multiline is-mobile">
        <div class="column is-12-mobile is-6-tablet is-3-desktop">
          <div class="control">
            <label class="label">{{ $t("shipmentQtyGraph.from_date") }}:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="start_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="start_date"
                class="is-fullwidth"
            ></date-picker>
          </div>
        </div>
        <div class="column is-12-mobile is-6-tablet is-3-desktop">
          <div class="control">
            <label class="label">{{ $t("shipmentQtyGraph.to_date") }}:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="end_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="end_date"
                class="is-fullwidth"
            ></date-picker>
          </div>
        </div>
        <div class="column is-12-mobile is-6-tablet is-3-desktop" v-if="$can('head-franchise')">
          <div class="control">
            <label class="label">{{ $t("shipmentQtyGraph.report_type") }}:</label>
            <div class="select is-fullwidth">
              <select class="input" v-model="report_type" @change="fetchData">
                <option value="shipment">{{ $t("shipmentQtyGraph.bills_count") }}</option>
                <option value="freight">{{ $t("shipmentQtyGraph.freight") }}</option>
                <option value="price">{{ $t("shipmentQtyGraph.goods_price") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-12-mobile is-6-tablet is-3-desktop">
          <div class="control">
            <label class="label">{{ $t("shipmentQtyGraph.amount_type") }}:</label>
            <div class="select is-fullwidth">
              <select class="input" v-model="shipment_type" @change="fetchData">
                <option value="created">{{ $t("shipmentQtyGraph.created_amount") }}</option>
                <option value="success">{{ $t("shipmentQtyGraph.delivered_amount") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="buttons is-centered-mobile">
            <button class="button is-rounded is-fullwidth-mobile" @click="printChartPDF()">
              <span class="icon">
                 <i class='fal fa-file-pdf'></i>
              </span>
              <span>PDF</span>
            </button>
            <button class="button is-primary is-rounded is-fullwidth-mobile" @click="printChartExcel()">
              <span class="icon">
                   <i class='fal fa-file-excel'></i>
              </span>
              <span>EXCEL</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="chartAreaWrapper">
      <barChart id="barChart"
                class="walking-speed-chart"
                v-if="!loaded"
                :chartData='chartData'
                :report_type="report_type"
                :style="{ width: responsiveChartWidth + 'px', minHeight: '400px', display: 'flex' }"
      />
    </div>
    <Loading v-if="loaded"/>
  </div>
</template>

<script>
import barChart from '@/components/Chart/BarChart'
import Exporter from "vue-chartjs-exporter";
import XLSX from 'xlsx'
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "@/views/Loading";

export default {
  name: "graph",
  data() {
    return {
      start_date: moment(new Date()).format('YYYY-MM-DD'),
      end_date: moment(new Date()).format('YYYY-MM-DD'),
      loaded: true,
      chartData: {
        labels: [],
        qty: [],
        freight: [],
        price: [],
      },
      excelData: {},
      count: 0,
      chartOptions: {},
      date_type: 'day',
      report_type: 'shipment',
      shipment_type: 'created'
    };
  },
  methods: {
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date > today;
    },

    printChartPDF() {
      let bar = document.getElementById("barChart");
      const exp = new Exporter([bar]);
      exp.export_pdf().then((pdf) => pdf.save(this.$t('shipmentQtyGraph.pdf_file_name', { from: moment(this.start_date).format('DD-MM-YYYY'), to: moment(this.end_date).format('DD-MM-YYYY') })));
    },
    printChartExcel() {
      const dataWS = XLSX.utils.json_to_sheet(this.excelData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, this.$t('shipmentQtyGraph.excel_file_name', { from: moment(this.start_date).format('DD-MM-YYYY'), to: moment(this.end_date).format('DD-MM-YYYY') }))
    },
    fetchData() {
      this.loaded = true
      this.$http.get("report/chart", {
        params: {
          report_type: this.report_type,
          shipment_type: this.shipment_type,
          start_date: this.start_date,
          end_date: this.end_date
        }
      }).then((res) => {
        const dataSet = {
          labels: [],
          qty: [],
          freight: [],
          price: [],
        };
        res.data.branch.map((item) => {
          dataSet.labels.push(item.name);
          dataSet.qty.push(item.qty);
          dataSet.freight.push(item.freight);
          dataSet.price.push(item.price);
          return item;
        })
        this.chartData = dataSet;
        if (this.report_type === 'shipment') {
          this.count = this.$t('shipmentQtyGraph.count_bills', { n: this.formatNumber(res.data.total_qty) })
        } else if (this.report_type === 'freight') {
          this.count = this.$t('shipmentQtyGraph.amount_kip', { n: this.formatNumber(res.data.total_freight) })
        } else {
          this.count = this.$t('shipmentQtyGraph.amount_kip', { n: this.formatNumber(res.data.total_price) })
        }
        this.excelData = res.data.branch;
        this.loaded = false
      }).catch((error) => {
        console.log(error)
        this.loaded = false
      });
    },
    formatNumber(value) {
      let p = value.toFixed(2).split(".");
      return p[0].split("").reverse().reduce(function (acc, value, i) {
        return value === "-" ? acc : value + (i && !(i % 3) ? "," : "") + acc;
      }, "")
    },
    handleResize() {
      // Force re-render on resize
      this.$forceUpdate();
    }
  },
  computed: {
    responsiveChartWidth() {
      const isMobile = window.innerWidth < 768;
      const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;
      
      if (isMobile) {
        const baseWidth = 30; // Wider bars on mobile for better touch
        return Math.max(this.chartData.labels.length * baseWidth, window.innerWidth - 40);
      } else if (isTablet) {
        const baseWidth = 25;
        return Math.max(this.chartData.labels.length * baseWidth, window.innerWidth - 60);
      } else {
        const baseWidth = 20;
        return Math.max(this.chartData.labels.length * baseWidth, window.innerWidth - 100);
      }
    }
  },
  
  mounted() {
    this.fetchData();
    window.addEventListener('resize', this.handleResize);
  },
  
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  watch: {
    'start_date': function () {
      this.fetchData();
    },
    'end_date': function () {
      this.fetchData();
    },
  },

  components: {
    barChart,
    DatePicker,
    Loading
  },
}
</script>

<style scoped lang="scss">
.chartAreaWrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 10px 0;
  
  @media (max-width: 768px) {
    padding: 5px 0;
  }
}

.walking-speed-chart {
  height: 100%;
  min-height: 400px;
  transition: width 0.3s ease;
  
  @media (max-width: 768px) {
    min-height: 300px;
  }
}

.countTotal {
  display: inline-block;
  word-break: break-word;
}

.box {
  @media (max-width: 768px) {
    padding: 1rem;
  }
}

.buttons {
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    
    .button {
      margin-bottom: 0.5rem;
      width: 100%;
    }
  }
  
  @media (min-width: 769px) {
    .button {
      margin-right: 0.5rem;
    }
  }
}

.select, .mx-datepicker {
  @media (max-width: 768px) {
    width: 100%;
  }
}

::v-deep .mx-datepicker {
  width: 100%;
  
  .mx-input {
    width: 100%;
  }
}
</style>
